import { FlowElement, withLoading } from 'prace-common-components'
import { clientApi } from '../..'
import {
  FlowDocument, FlowDocumentVersion, CreateDocumentsPayload, AddDocumentVersionPayload, DocumentUrlResponse,
} from './types'

export const documentsApi = clientApi.injectEndpoints({
  endpoints: (build) => ({
    getElementDocuments: build.query<FlowDocument[], FlowElement['id']>({
      ...withLoading,
      query: (elementId) => ({ url: `/v2/documents/element/${elementId}` }),
    }),
    createDocuments: build.mutation<FlowDocument[], CreateDocumentsPayload>({
      ...withLoading,
      query: ({ flowElementId, files }) => {
        const data = new FormData()
        data.append('flowElementId', String(flowElementId))
        files.forEach((file) => data.append('files', file))
        return {
          url: '/v2/documents',
          method: 'POST',
          body: data,
          formData: true,
        }
      },
    }),
    addDocumentVersion: build.mutation<FlowDocumentVersion, AddDocumentVersionPayload>({
      ...withLoading,
      query: ({ id, file }) => {
        const data = new FormData()
        data.append('files', file)
        return {
          url: `/v2/documents/${id}/version`,
          method: 'POST',
          body: data,
          formData: true,
        }
      },
    }),
    deleteDocument: build.mutation<{ id: number }, FlowDocument['id']>({
      ...withLoading,
      query: (id) => ({
        url: `/v2/documents/${id}`,
        method: 'DELETE',
      }),
    }),
    getDocumentVersionUrl: build.query<DocumentUrlResponse, FlowDocumentVersion['id']>({
      query: (versionId) => ({ url: `/v2/documents/version/${versionId}/url` }),
    }),
  }),
})

export const {
  useGetElementDocumentsQuery,
  useCreateDocumentsMutation,
  useAddDocumentVersionMutation,
  useDeleteDocumentMutation,
  useLazyGetDocumentVersionUrlQuery,
} = documentsApi
